import { IconButtonProps, IconButton } from '@mui/material';
import { ReactElement } from 'react';
import PopupMenu, { PopupMenuProps } from './PopupMenu';

export interface IconButtonMenuProps extends PopupMenuProps, Omit<IconButtonProps, 'children'> {
  icon: ReactElement;
}

export const IconButtonMenu: React.FC<IconButtonMenuProps> = ({
  items,
  row,
  icon,
  menuProps,
  ...buttonProps
}) => (
  <PopupMenu items={items} row={row} menuProps={menuProps}>
    <IconButton {...buttonProps}>{icon}</IconButton>
  </PopupMenu>
);
